import styled from 'styled-components';
import fontSettings from '@sdk/theme/fonts';
import FaceSVG from '@sdk/assets/svg/UI/face.svg';

export const ButtonIcon = styled(FaceSVG)`
  color: inherit;
  transition: inherit;
`;

type ButtonProps = {
  isActive: boolean;
};

export const Button = styled.button<ButtonProps>`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0;
  color: ${({ isActive, theme }) => theme.colors[isActive ? 'primary' : 'iconGray']};
  cursor: pointer;
  display: flex;
  font: normal 400 16px/1 ${fontSettings.fontFamily};
  gap: 3px;
  height: 24px;
  justify-content: center;
  min-width: 24px;
  padding: 0;
  pointer-events: auto;
  transition: color 0.25s linear;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
